import {
  ProviderGroupControllerApiFactory
} from "../../services";
import {
  getConfigObject,
  useMutationWithLoading,
} from "../../utils/utils";

/**
 *
 * @author Atish Bagate
 */

export interface SendInviteProps {
  providerGroupId: string;
  xTENANTID?: string;
}

export const useSendInvite = () =>
  useMutationWithLoading(
    ({ providerGroupId, xTENANTID  }: SendInviteProps) =>
      ProviderGroupControllerApiFactory(getConfigObject())
        .sendScriptsureInvite(providerGroupId, xTENANTID)
  );
